/* ============================================
   ABC Cooking MARKET — よみもの記事用JS
   assets/abc-article.js
   機能：目次の自動生成・開閉トグル
   ============================================ */

document.addEventListener('DOMContentLoaded', function(){

  /* ── 目次 自動生成 ── */
  var tocList = document.getElementById('abc-toc-list');
  var toc     = document.getElementById('abc-toc');

  if(tocList && toc){
    var article = document.querySelector('.article__body, .rte, article');
    if(article){
      var headings = article.querySelectorAll('h2');
      var count = 0;

      headings.forEach(function(h, i){
        if(h.closest('.abc-toc')) return; // 目次自身はスキップ
        var id = 'abc-heading-' + i;
        h.setAttribute('id', id);

        var li = document.createElement('li');
        li.className = 'abc-toc__item';

        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent;
        a.addEventListener('click', function(e){
          e.preventDefault();
          var target = document.getElementById(id);
          if(target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });

        li.appendChild(a);
        tocList.appendChild(li);
        count++;
      });

      // h2が1つもなければ目次ごと非表示
      if(count === 0) toc.style.display = 'none';
    }
  }

  /* ── 目次 開閉トグル ── */
  var tocHeader = document.querySelector('.abc-toc__header');
  var tocBody   = document.getElementById('abc-toc-body');
  var tocToggle = document.getElementById('abc-toc-toggle');

  if(tocHeader && tocBody && tocToggle){
    tocHeader.addEventListener('click', function(){
      var isOpen = tocBody.style.display !== 'none';
      tocBody.style.display = isOpen ? 'none' : 'block';
      tocToggle.textContent = isOpen ? '開く' : '閉じる';
    });
  }

});


/* ============================================
   関連商品 自動取得
   Shopify Search API を使用（無料・アプリ不要）
   使い方：
   <div class="abc-auto-products" data-query="パン 強力粉" data-limit="4"></div>
   ※ クエリは短くシンプルに（日本語2〜3語 or 英語推奨）
   data-limit で表示件数を指定（省略時は4件）
   ============================================ */
(function(){
  var containers = document.querySelectorAll('.abc-auto-products');
  if(!containers.length) return;

  containers.forEach(function(container){
    var query = container.getAttribute('data-query') || '';
    var limit = parseInt(container.getAttribute('data-limit')) || 4;
    if(!query) return;

    container.innerHTML = '<p style="font-size:13px;color:#9A7A5A;padding:16px 0;">関連商品を読み込み中...</p>';

    var lang = document.documentElement.lang || 'ja';
    var apiUrl = '/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=' + limit
      + '&locale=' + lang;

    // fetchはswymに上書きされて417エラーになるのでXHRを使う
    var xhr = new _nativeXHR();
    xhr.open('GET', apiUrl, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function(){
      if(xhr.status !== 200){ container.innerHTML = ''; return; }
      var data;
      try { data = JSON.parse(xhr.responseText); } catch(e){ container.innerHTML = ''; return; }
      if(!data || !data.resources || !data.resources.results){
        container.innerHTML = ''; return;
      }
      var products = data.resources.results.products || [];
      if(!products.length){ container.innerHTML = ''; return; }

      var html = '<div class="abc-product-grid">';
      products.forEach(function(p){
        var imgUrl = '';
        if(p.featured_image && p.featured_image.url){
          imgUrl = p.featured_image.url
              .replace(/(\.[a-z]+)(\?|$)/, '_400x400$1$2');
          }
          var title = p.title || '';
          var url   = p.url || '#';

          html += '<a href="' + url + '" class="abc-product-grid__item">';
          if(imgUrl){
            html += '<div class="abc-product-grid__item__thumb">'
                  + '<img src="' + imgUrl + '" alt="' + title + '" loading="lazy">'
                  + '</div>';
          }
          html += '<div class="abc-product-grid__item__body">'
                + '<p class="abc-product-grid__item__name">' + title + '</p>'
                + '<span class="abc-product-grid__item__btn">商品を見る →</span>'
                + '</div></a>';
        });
        html += '</div>';
        container.innerHTML = html;
    };
    xhr.onerror = function(){ container.innerHTML = ''; };
    xhr.send();
  });
})();